import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { categoriesAPI } from '@/lib/api';
import { Card, CardContent } from '@/components/ui/card';
import { Laptop, Monitor, Smartphone, Camera, Printer, Cable } from 'lucide-react';
import Layout from '@/components/Layout';

const iconMap = {
  'Laptop': Laptop,
  'Monitor': Monitor,
  'Smartphone': Smartphone,
  'Camera': Camera,
  'Printer': Printer,
  'Cable': Cable
};

const CategoriesPage = () => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadCategories();
  }, []);

  const loadCategories = async () => {
    try {
      const data = await categoriesAPI.getAll();
      setCategories(data);
    } catch (error) {
      console.error('Error loading categories:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout>
      <div className="section-padding" style={{ background: 'var(--color-background)' }}>
        <div className="container-custom">
          {/* Header */}
          <div className="text-center mb-16">
            <h1 className="text-5xl font-bold mb-6" style={{ color: 'var(--color-text-primary)' }}>
              Shop by Category
            </h1>
            <p className="text-xl" style={{ color: 'var(--color-text-secondary)' }}>
              Explore our complete range of premium technology products
            </p>
          </div>

          {/* Categories Grid */}
          {loading ? (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {[1, 2, 3, 4, 5, 6].map((i) => (
                <div key={i} className="skeleton h-64 rounded-2xl"></div>
              ))}
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {categories.map((category) => {
                const Icon = iconMap[category.icon] || Laptop;
                return (
                  <Link
                    key={category.id}
                    to={`/products?category=${category.id}`}
                    data-testid={`category-${category.id}`}
                  >
                    <Card className="luxury-card h-full cursor-pointer">
                      <CardContent className="p-8 text-center space-y-6">
                        <div className="flex justify-center">
                          <div
                            className="h-24 w-24 rounded-full flex items-center justify-center"
                            style={{
                              background: 'var(--color-accent)',
                              color: 'var(--color-text-on-accent)'
                            }}
                          >
                            <Icon size={48} />
                          </div>
                        </div>
                        <div>
                          <h3 className="text-2xl font-bold mb-2" style={{ color: 'var(--color-text-primary)' }}>
                            {category.name}
                          </h3>
                          <p style={{ color: 'var(--color-text-secondary)' }}>
                            {category.description}
                          </p>
                        </div>
                      </CardContent>
                    </Card>
                  </Link>
                );
              })}
            </div>
          )}
        </div>
      </div>
    </Layout>
  );
};

export default CategoriesPage;